
require('../vendor/frontoffice/js/main');

require('bootstrap/dist/js/bootstrap.min');
require('bootstrap/dist/js/bootstrap');

require('bootstrap-select/dist/js/bootstrap-select.min.js');
require('jquery-form');
require('jquery-mapael/js/maps/france_departments.js');
require('jquery-mapael');

//Necessaire pour le page builder
window.toastr = require('toastr');
require('./../../vendor/hegyd/core/js/hegyd-core.js');
import 'jquery-validation/dist/localization/messages_fr.js';
import 'select2';

require('./tarteaucitron');
require('./tarteucitronlistcookies');